// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"L4-z","colorTextValue":"M4-z","swatches":"N4-z","collapseLink":"O4-z","isCollapsed":"P4-z","dropdown":"Q4-z","disabled":"R4-z"};